import React from 'react';
import { TextFieldProps } from '@mui/material';
import TextField from './TextField';

const EmailTextField = (props: TextFieldProps) => (
  <TextField {...props} type="email" inputMode="email" />
);

export default EmailTextField;
